var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServ(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "27px",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-1609.000000, -36.000000)",
    stroke: "",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(1508.000000, 37.628133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv",
    transform: "translate(103.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.8812255 C0,9.55903775 1.10444795,8.46569116 2.46876571,8.46569116 C4.8205897,8.46569116 5.78210886,6.83838264 4.59970005,4.84238747 C3.92403791,3.69818649 4.3268362,2.21072508 5.50924502,1.54963119 L7.75712108,0.291010106 C8.78360785,-0.306517087 10.1089454,0.0494566758 10.7196401,1.05381092 L10.8625681,1.29536424 C12.0319834,3.2913594 13.9550218,3.2913594 15.1374306,1.29536424 L15.2803599,1.05381092 C15.8910546,0.0494566758 17.2163928,-0.306517087 18.2428795,0.291010106 L20.490755,1.54963119 C21.6731638,2.21072508 22.0759608,3.69818649 21.4002987,4.84238747 C20.2178899,6.83838264 21.1794109,8.46569116 23.5312349,8.46569116 C24.8825592,8.46569116 26,9.54632442 26,10.8812255 L26,13.1187745 C26,14.4409623 24.8955527,15.5343094 23.5312349,15.5343094 C21.1794109,15.5343094 20.2178899,17.1616168 21.4002987,19.1576119 C22.0759608,20.3145263 21.6731638,21.7892757 20.490755,22.4503696 L18.2428795,23.7089904 C17.2163928,24.3065176 15.8910546,23.9505459 15.2803599,22.9461917 L15.1374306,22.7046374 C13.9680154,20.7086423 12.044977,20.7086423 10.8625681,22.7046374 L10.7196401,22.9461917 C10.1089454,23.9505459 8.78360785,24.3065176 7.75712108,23.7089904 L5.50924502,22.4503696 C4.3268362,21.7892757 3.92403791,20.3018129 4.59970005,19.1576119 C5.78210886,17.1616168 4.8205897,15.5343094 2.46876571,15.5343094 C1.10444795,15.5343094 0,14.4409623 0,13.1187745 L0,10.8812255 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9935031,15.8140846 C10.840669,15.8140846 9.09545217,14.1064972 9.09545217,12.0000812 C9.09545217,9.89366531 10.840669,8.18607787 12.9935031,8.18607787 C15.1463372,8.18607787 16.891554,9.89366531 16.891554,12.0000812 C16.891554,14.1064972 15.1463372,15.8140846 12.9935031,15.8140846 Z",
    id: "Vector"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServ);
export default __webpack_public_path__ + "static/media/serv.cb4c7481248603cd5c7f74599cb01310.svg";
export { ForwardRef as ReactComponent };